


import { useMediaQuery } from "@mui/material";


const UnitUnavailableDialog = ({ open,onClose }) => {
  // const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '2rem 1.5rem',
          borderRadius: '8px',
          width:isMobile?'300px': '400px',
          maxWidth: '100%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          position:'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          style={{
            position: 'absolute',
            top:isMobile?'10px': '15px',
            right: isMobile?'10px':'15px',
            background: 'transparent',
            border: 'none',
            fontSize: '2rem',
            cursor: 'pointer',
          }}
          onClick={onClose}
        >
          <span  style={{color:"#9fa6b3"}}>X</span>
        </button>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: '2rem 1.5rem',
          }}
        >
          <div
            style={{
              width: '8rem',
              height: '8rem',
              borderRadius: '50%',
              backgroundColor: '#fff2e8', // Use your defined color here
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem',
              animation: 'scaleIn 0.3s ease-out',
            }}
          >
            <div
              style={{
                width: '5rem',
                height: '5rem',
                borderRadius: '50%',
                border: '3.5px solid #ff1919', // Use your defined color here
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ff1919', // Use your defined color here
                fontSize: '2rem',
                lineHeight:'3rem',
                fontWeight: 'bold',
              }}
            >
              !
            </div>
          </div>

          <h2
            style={{
              fontSize:isMobile?'2.5rem':  '2rem',
              fontWeight: '550',
              color: 'hsl(var(--foreground))', // Use your defined color here
              marginBottom: '0.75rem',
            }}
          >
          Unit Not Available
          </h2>

          <p
            style={{
              fontSize: isMobile?'1.5rem': '1.1rem',
              color: '#98a2b3', // Use your defined color here
              lineHeight: '1.5',
              marginBottom: '1.5rem',
            }}
          >
           Sorry, the selected unit is no longer available. Please try selecting another unit.
          </p>

          <button
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              padding: '7px 7px',
              fontSize: '13px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              width: isMobile?'40%':'30%',
             
            }}
            onClick={onClose}
            
          >
            Back 
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnitUnavailableDialog;
